import * as THREE from 'three';

export default class RoundedSceneStencilMaterial extends THREE.RawShaderMaterial {
  constructor(props?: { padding?: number; radius?: number; depth?: boolean }) {
    super();

    // Merge custom props with default options
    const opts = Object.assign(
      {
        padding: 50,
        radius: 20,
        depth: false,
      },
      props,
    );

    this.name = 'RoundedSceneStencilMaterial';
    this.glslVersion = THREE.GLSL3;
    this.depthTest = opts.depth;
    this.transparent = false;

    this.uniforms = {
      padding: { value: opts.padding },
      radius: { value: opts.radius },
      screenWidth: { value: 0 },
      screenHeight: { value: 0 },
    };

    this.vertexShader = `
        in	vec3    position;
        in  vec3    normal;
        in	vec2    uv;

        uniform mat4  modelMatrix;
        uniform mat4  viewMatrix;
        uniform mat4  projectionMatrix;

        out vec3 fragLPos;
        out vec2 fragUV;

        // #####################################################################

        void main(){
            fragUV      = uv;
            gl_Position = vec4( position.xy, 0.0, 1.0 );
        }`;

    this.fragmentShader = `precision mediump float;
        in vec2  fragUV;
        out vec4 outColor;

        uniform float screenWidth;
        uniform float screenHeight;
        uniform float radius;
        uniform float padding;

        // #####################################################################

        float roundedRect( vec2 px, vec2 res, float padd, float radius ){
            vec2 dist        = abs( px - res * 0.5 );                           // Distance from center of screen
            float radialDist = padd + radius;                                   // Padd away from edges, then add a radius curve to it
            vec2 roundDist   = max( dist - ( res * 0.5 - radialDist ), 0.0 );   // Create padding mask for x & y
            float roundLen   = length( roundDist );                             // Square Mask
            float final      = 1.0 - step( radius, roundLen );                  // Square with rounded corners mask
            return final;
        }

        void main(){
            vec2 res    = vec2( screenWidth, screenHeight );
            vec2 px     = res * fragUV; // gl_FragCoord.xy; can't use gl_FragCoord in mini view, using actual canvas pixel coord
            float mask  = roundedRect( px, res, padding, radius );
            
            if( mask < 0.5 ) discard; // outColor = vec4( 0.0, 0.0, 0.0, 1.0 ); 
            else             outColor = vec4( 1.0 );
        }`;
  }

  setScreenSize(x: number, y: number) {
    this.uniforms.screenWidth.value = x;
    this.uniforms.screenHeight.value = y;
    return this;
  }
}
